/**
 * USASpending data constants
 */

/**
 * First fiscal year with reliable outlay data (FY2022 = Oct 1, 2021).
 *
 * The Digital Accountability and Transparency Act (DATA Act, P.L. 113-101, 2014)
 * required federal agencies to report standardized, machine-readable data on
 * federal spending — including obligations and outlays — expanding the earlier
 * Federal Funding Accountability and Transparency Act (FFATA) of 2006. This led
 * to USAspending.gov as the public reporting platform. Outlay reporting became
 * reliable starting FY2022; outlay statistics are only meaningful from this
 * point forward.
 */
export const OUTLAY_REPORTING_START_FY = 2022
